//Parts Filter Reducer
import moment from 'moment';
//Need to reset the begin date to the last date of the previous month and then subtract the difference between 7 and the current date
//to get the correct date for one week before today if today is within the first week of the month
const laborProcessFiltersReducerDefaultState = {
    beginDate : moment().utc().subtract(7,'day').format('YYYY-MM-DD'),
    endDate   : moment().utc().format('YYYY-MM-DD'),
    version   : 'V1.0'
};

export default (state = laborProcessFiltersReducerDefaultState, action) => {
    switch(action.type) {
        case 'SET_BEGIN_DATE_LABOR_PROCESS_FILTER':
            return {
                ...state,
                beginDate : action.beginDate
            };
        case 'SET_END_DATE_LABOR_PROCESS_FILTER':
            return {
                ...state,
                endDate : action.endDate
            };
        case 'SET_FORMAT_VERSION_LABOR_PROCESS_FILTER':
            return {
                ...state,
                version : action.version
            };

        case 'SET_LABOR_PROCESS_FILTERS':
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/Reducers/laborProcessFilters.js